// エラー処理関係

/** エレメントの後にエラーメッセージを追加する */
export function addErrorMessage(element, message) {
    element.addClass('is-invalid');
    element.after(`<span class='invalid-feedback' role='alert'><strong>${message}</strong></span>`);
}
